import React from 'react';
import { ADMIN_EMPTY_STATE_ICON_BG } from '@/config/adminChartTheme';

interface EmptyUsersStateProps {
  hasFilters: boolean;
  onClearFilters?: () => void;
}

const EmptyUsersState: React.FC<EmptyUsersStateProps> = ({
  hasFilters,
  onClearFilters,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div
        className={`w-[120px] h-[120px] rounded-full flex items-center justify-center mb-6 ${ADMIN_EMPTY_STATE_ICON_BG}`}
      >
        <img
          src="/assets/users.svg"
          alt="No users"
          className="w-[60px] h-[60px] opacity-50"
        />
      </div>

      {hasFilters ? (
        <>
          <h3 className="text-xl font-semibold text-[#292828] mb-2">
            No users found
          </h3>
          <p className="text-[#9B919D] text-sm mb-6 text-center max-w-md">
            We couldn&apos;t find any users matching your filters. Try adjusting
            your search criteria.
          </p>
          {onClearFilters && (
            <button
              onClick={onClearFilters}
              className="px-6 py-2 bg-[#3C2479] text-white rounded-xl hover:bg-[#322066] transition-colors"
            >
              Clear Filters
            </button>
          )}
        </>
      ) : (
        <>
          <h3 className="text-xl font-semibold text-[#292828] mb-2">
            No users yet
          </h3>
          <p className="text-[#9B919D] text-sm text-center max-w-md">
            When users sign up to your platform, they will appear here.
          </p>
        </>
      )}
    </div>
  );
};

export default EmptyUsersState;
